@if (cake) {
  <div class="ws-product-detail__header"
       [class.cake-info-container]="standAloneMode"
       [class.container-fluid]="!standAloneMode"
       [class.no-image-container]="!hasImage">
    <div class="row">
      @if (hasImage) {
        <div class="ps-0 pr-sm-max-0"
             [class.col-md-5]="!standAloneMode"
             [class.col-md-6]="standAloneMode">
          @if (!disabledBackButton) {
            <div class="gradient-container d-block d-md-none">
              <i (click)="onBackButtonClicked.emit()"
                 class="icon-chevron-left text-white d-inline-block p-3"></i>
            </div>
          }

          <product-image-gallery
            [images]="cake.images"
            [alt]="cake?.bakery?.name + ' - ' + cake?.name">
            @if (cake.discount?.value || (showCustomNote && !!noteLabel)) {
              <div productImgOverlay
                   class="cake-info-img-badges flex-column align-items-end">
                @if (cake.discount?.value) {
                  <ui-discount-badge
                    class="ws-product-detail__discount"
                    [value]="cake.discount?.value"
                    [class.mb-2]="showCustomNote && !!noteLabel"
                  ></ui-discount-badge>
                }

                @if (showCustomNote && !!noteLabel) {
                  <div class="badge badge__top-left ws-product-detail__badge {{ CUSTOM_NOTE_COLOR_MAP[noteLabel?.colorType] || 'badge__top-left' }}">
                    {{ noteLabel.text }}
                  </div>
                }
              </div>
            }
          </product-image-gallery>
        </div>
      }

      <div [class.col-md-7]="!standAloneMode && hasImage"
           [class.col-md-6]="standAloneMode && hasImage"
           [class.col-md-12]="!hasImage">

        <div class="pt-sm-max-3"
             [class.pt-sm-min-4]="!standAloneMode && hasImage">
          <h1 class="cake-name ws-product-detail__title"
              [class.pr-md-min-4]="!standAloneMode && hasImage">{{cake.name}}</h1>

          @if (showBakeryInfo) {
            <div class="bakery-info-line font-md mt-1">
              @if (bakeryUrl) {
                <div class="d-flex flex-nowrap mb-xs-max-2">
                  <div class="me-1" [translate]="'common.from'"></div>

                  <a class="text-gray-0 text-underline nowrap"
                     [href]="bakeryUrl"
                     (click)="$event.preventDefault(); onBakeryNameClicked.emit(cake.bakery.name)">
                    {{cake.bakery.name}}
                  </a>

                  <div class="delivery-params-separator">|</div>
                </div>
              }

              @if (isPickUpOnly) {
                <ng-container *ngTemplateOutlet="pickupLine"></ng-container>
              }

              @if (isDeliveryOnly) {
                <ng-container *ngTemplateOutlet="deliveryLine"></ng-container>
              }

              @if (isPickUpAndDelivery) {
                <div class="d-flex nowrap">
                  <ng-container *ngTemplateOutlet="pickupLine"></ng-container>
                  <div class="mx-1">{{'common.or' | translate}}</div>
                  <ng-container *ngTemplateOutlet="deliveryLine"></ng-container>
                </div>
              }
            </div>
          }

          @if (isConcreteProductType) {
            @if (isComplexWithOneSize) {
              <ui-size-shape-info
                class="d-block my-4"
                [size]="cake?.sizes[0]"
                [currency]="currency"
                [discount]="cake.discount?.value"
              ></ui-size-shape-info>
            }

            @if (!isComplexWithOneSize) {
              <cake-info-price
                class="d-block mt-sm-min-3 mt-xs-max-2"
                [price]="minPrice"
                [discount]="cake.discount?.value"
                [isSinglePiecesCake]="isSinglePiecesCake"
                [currency]="cake.bakery?.country?.currencySymbol"
                [unitName]="isSinglePiecesCake
                              ? (('cakeBuilder.sizeUnits.unitType.' + cake?.sizes[0].details?.unit?.key) | translate)
                              : ''"
              ></cake-info-price>
            }
          }
        </div>

        <cake-info-tabs
          class="d-block mt-sm-min-4 mt-xs-max-3"
          [class.tabs-for-no-image-cake]="!hasImage"
          [cake]="cake"
          [showBakeryDeadline]="showBakeryDeadline"
          [orderDeadlines]="orderDeadlines"
          [specialDeadlines]="specialDeadlines"
        ></cake-info-tabs>

        <ng-content></ng-content>
      </div>
    </div>
  </div>
}

<ng-template #pickupLine>
  <div class="text-underline pointer nowrap"
       (click)="showPickup()">
    {{ 'orderProcess.cakesOverview.cakeItem.pickupPoints' | translate: { count: cake.outletsCount } }}
  </div>
</ng-template>

<ng-template #deliveryLine>
  @if (!isThirdPartyAvailable) {
    <div class="text-underline pointer nowrap"
         (click)="showDelivery()">
      {{ 'cakeBuilder.checkDeliveryPrice' | translate }}
    </div>
  }

  @if (isThirdPartyAvailable) {
    <div class="nowrap">
      {{ 'orderProcess.cakesOverview.cakeItem.getDelivery' | translate }}
    </div>
  }
</ng-template>
